import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SIDEBAR_POSITIONS, TRANSITION_DURATION } from 'components/Sidebar/sidebarSettings';
import { DrawerComponent } from 'components/Drawer/Drawer';
import { SidebarContext } from './SidebarContext';

import useStyles from './styles';
import { CloseButton } from './components/CloseButton';

export { SidebarContext };

export const Sidebar = ({
  isOpen = false,
  handleClose,
  children,
}) => {
  const classes = useStyles();
  /*
  * isTransitionEntered state
  * Entered - true
  * Exited - false
  */
  const [isTransitionEntered, setIsTransitionEntered] = useState(false);
  const transitionEnteredState = useMemo(() => ({ isTransitionEntered }), [isTransitionEntered]);
  const setTransitionEntered = useCallback(() => {
    setIsTransitionEntered(true);
  }, []);

  const setTransitionExited = useCallback(() => {
    setIsTransitionEntered(false);
  }, []);
  return (
    <DrawerComponent
      transitionDuration={TRANSITION_DURATION}
      anchor={SIDEBAR_POSITIONS.RIGHT}
      className={classes.root}
      slideProps={{
        onEntered: () => setTransitionEntered(),
        onExited: () => setTransitionExited(),
      }}
      open={isOpen}
      onClose={handleClose}
    >
      <SidebarContext.Provider value={transitionEnteredState}>
        <CloseButton onClick={handleClose} />
        {children}
      </SidebarContext.Provider>
    </DrawerComponent>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
